import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-04/lesson-28/task-01";

const task: Slide = {
  titleHtml: "A linear array made of 15 speakers equally spaced from 20 cm<br>and driven with the same signal.",
  description: "Select the correct answer(s).",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
